// extracted by mini-css-extract-plugin
export default {"commentaries":"search_result_commentaries-module__commentaries--3jyNP"};